import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f289f3f0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f289f3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f289f3f0')) {
      api.createRecord('f289f3f0', component.options)
    } else {
      api.reload('f289f3f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f289f3f0&scoped=true&", function () {
      api.rerender('f289f3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/area/index.vue"
export default component.exports